import { memo, useState } from 'react';

import { Props } from './types';

// Vendor logos live in public/images/outlinks/; a missing file falls back to a monogram so a
// new system can ship before its artwork does.
const OutlinkLogo = ({ monochrome = false, name, src }: Props) => {
  const [hasFailed, setHasFailed] = useState(false);

  if (hasFailed) {
    return (
      <span
        aria-hidden
        className="inline-flex h-4 w-4 shrink-0 items-center justify-center rounded-sm bg-current/15 text-[0.625rem] font-bold leading-none">
        {name.charAt(0)}
      </span>
    );
  }

  // A mask can't report a missing file, so a hidden image still watches for the load failing.
  if (monochrome) {
    return (
      <span
        aria-hidden
        className="h-4 w-4 shrink-0 bg-current mask-contain mask-center mask-no-repeat"
        data-testid="outlink-logo-mask"
        style={{ maskImage: `url(${src})` }}>
        <img alt="" className="hidden" onError={() => setHasFailed(true)} src={src} />
      </span>
    );
  }

  return (
    <img
      alt=""
      className="h-4 w-4 shrink-0 rounded-sm object-contain"
      onError={() => setHasFailed(true)}
      src={src}
    />
  );
};

export default memo(OutlinkLogo);
